import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const addRouteForPoc = async (geoJson) => {
  try {
    const response = await apiClient.post(`/routes/createRoute/`, geoJson);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
